export enum FORM_NAMES {
  BILLING_FREQUENCY = 'billingFrequency',
  TERM_LENGTH = 'termLength',
  SKIP_TRIAL = 'skipTrial',
  CUSTOM_PROMOTION = 'customPromotion',
  OFFERING = 'offering',
  USER_TIER = 'userTier',
  PRICING_PLAN = 'pricingPlan',
  PURCHASE_FOR = 'purchaseFor',
}
